// Recherche Ghost (sodo-search) : la fenêtre est une iframe de même origine ; on y reflète le mode sombre du site.
export default function recherche() {
    const html = document.documentElement;
    const sombre = () => html.dataset.theme === "dark" || (!html.dataset.theme && matchMedia("(prefers-color-scheme: dark)").matches);
    function appliquer() {
        const iframe = document.querySelector("#sodo-search-root iframe");
        const doc = iframe && iframe.contentDocument;
        if (doc && doc.documentElement) doc.documentElement.classList.toggle("theme-dark", sombre());
    }
    // L'iframe est créée par le script Ghost après le chargement ; on l'attend, puis on suit les changements de mode
    const attente = setInterval(() => { if (document.querySelector("#sodo-search-root iframe")) { clearInterval(attente); appliquer(); } }, 300);
    setTimeout(() => clearInterval(attente), 20000);
    new MutationObserver(appliquer).observe(html, { attributes: true, attributeFilter: ["data-theme"] });
    matchMedia("(prefers-color-scheme: dark)").addEventListener("change", appliquer);
    document.addEventListener("click", (e) => { if (e.target.closest("[data-ghost-search]")) setTimeout(appliquer, 50); });
}
